export default __webpack_public_path__ + "static/media/shape3.410538b0.svg";